import React from "react";
import Redirect from "react-router-dom/es/Redirect";
import ServiceLogout from "./ServiceLogout";

async function removeItemValue(key) {
  try {
    await localStorage.removeItem(key);
    return true;
  } catch (exception) {
    return false;
  }
}

const ServiceRedirect = (props) => {
  if (props.link === "/login") {
    return <ServiceLogout />;
  }
  if (props.link === "/dashboard") {
    return <Redirect from="/" to="/dashboard" />;
  }

  return <Redirect to={props.link} />;
};

export { ServiceRedirect };
